<div class="row__header">
  <div class="col__filter charging"></div>
  <div class="col__banner charging">
    <div class="powered">
      POWERED BY CANTINE<a
        href="https://www.cantine.wine"
        target="_blank"
        class="bold__logo"
        >.WINE</a
      >
    </div>
  </div>
  <div class="col__cart charging"></div>
</div>

<div class="row__charging">
  <div class="col__charging" *ngFor="let item of itemsCharging">
    <div class="item-charging">
      <div class="image">
        <img
          class="icon__charging"
          src="https://www.cantine.wine/gestione/img/cantine/no-imageVino.jpg"
          alt=""
        />
      </div>
      <div class="charging__top">
        <div class="charging winery"></div>
        <div class="charging name"></div>
        <div class="charging button"></div>
      </div>
    </div>
  </div>
</div>
